
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vn",
      function () {
        return require("private-next-pages/vn/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vn"])
      });
    }
  